module.exports = __webpack_public_path__ + "img/outlander1.500d209a.jpeg";